export const apiField = 'rafter_spacing_inches';

export const makeConfig = (label: string = 'rafterSpacing', min: number = 1, max: number = 144) => {
  return {
    type: "Number",
    label,
    apiField,
    min,
    max,
    missing: undefined, 
  }
}

function labelChange(roof_type, metric){
  let labelField = metric ? 'rafterSpacingMetric' : 'rafterSpacing';
  if(([s5AttachmentEnableRoofTypes.STANDING_SEAM_METAL_ROOF, s5AttachmentEnableRoofTypes.R_PANEL_ROOF] as number[]).includes(roof_type) ){
    if(metric){
      labelField = 'ribOrSeamSpacingMetric'
    }else{
      labelField = 'ribOrSeamSpacing'
    }
  }
  return labelField;
}

const s5AttachmentEnableRoofTypes = Object.freeze({
  STANDING_SEAM_METAL_ROOF : 2,
  R_PANEL_ROOF: 5,
});

const config = (roof_type?) => makeConfig(labelChange(roof_type, false));

export const rafterSpacingMetric = (roof_type?) => makeConfig(labelChange(roof_type, true),  2, 366)

export default config;
